import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";

export default function Header({ settings, base = "" }) {
  const [open, setOpen] = useState(false);
  const nav = settings?.nav || [];

  const href = (slug) => (slug === "home" ? `${base}/` : `${base}/${slug}`);

  return (
    <header className="relative z-40 border-b border-ink/10 bg-paper" data-testid="site-header">
      <div className="flex w-full items-center justify-between px-6 sm:px-16 lg:px-24 py-1">
        <Link to={`${base}/`} data-testid="header-logo-link" className="flex items-center gap-4 shrink-0">
          <img src="/logo.png" alt={settings?.brand_name || "Chef Blaine Guillot"} className="h-14 sm:h-16 w-auto" data-testid="header-logo-image" />
          <span className="hidden xl:inline font-serif text-2xl font-bold text-ink tracking-tight">{settings?.brand_name || "Chef Blaine Guillot"}</span>
        </Link>
        <nav className="hidden lg:flex items-center gap-8" data-testid="header-nav">
          {nav.map((item, i) => (
            <Link key={i} to={href(item.slug)} data-testid={`nav-link-${item.slug}`} className="text-sm text-ink2/70 transition-colors hover:text-gold tracking-wide">
              {item.label}
            </Link>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-5">
          {settings?.phone && (
            <a href={`tel:${settings.phone}`} data-testid="header-phone-link" className="flex items-center gap-2 text-sm text-ink2/70 hover:text-gold transition-colors">
              <Phone size={14} /> {settings.phone}
            </a>
          )}
          <Link to={`${base}/contact`} data-testid="header-book-button" className="rounded-full border border-brass/50 px-6 py-2.5 text-xs font-semibold uppercase tracking-widest text-gold transition-all hover:bg-brass hover:text-cast">
            Book Now
          </Link>
        </div>
        <button className="lg:hidden text-ink" onClick={() => setOpen(!open)} data-testid="mobile-menu-button" aria-label="Menu">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <motion.nav initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }} className="lg:hidden bg-paper/95 backdrop-blur-xl border-t border-brass/10 px-6 py-6 flex flex-col gap-4" data-testid="mobile-nav">
          {nav.map((item, i) => (
            <Link key={i} to={href(item.slug)} onClick={() => setOpen(false)} data-testid={`mobile-nav-link-${item.slug}`} className="text-lg font-serif text-ink2 hover:text-gold transition-colors">
              {item.label}
            </Link>
          ))}
        </motion.nav>
      )}
    </header>
  );
}
